<template>
  <div class="payment-banner">
    <img :src="img_gopay_color" v-bind="iconProps" alt="" />
    <img :src="img_visa_verif" v-bind="iconProps" alt="" />
    <img :src="img_mc_sec" v-bind="iconProps" alt="" />
    <img :src="img_visa_white" v-bind="iconProps" alt="" />
    <img :src="img_visa_color" v-bind="iconProps" alt="" />
    <img :src="img_mc_white" v-bind="iconProps" alt="" />
    <img :src="img_mc_elec" v-bind="iconProps" alt="" />
    <img :src="img_maestro" v-bind="iconProps" alt="" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      img_gopay_color: require("../assets/gopay_color.png"),
      img_visa_verif: require("../assets/visa_verified.png"),
      img_mc_sec: require("../assets/mc_secure.png"),
      img_visa_white: require("../assets/visa_white.png"),
      img_visa_color: require("../assets/visa_color.png"),
      img_mc_white: require("../assets/mc_white.png"),
      img_mc_elec: require("../assets/mc_elec.png"),
      img_maestro: require("../assets/maestro.png"),
      iconProps: { height: 40, class: "ml-2" },
    };
  },
};
</script>
